import axios from 'axios'
// eslint-disable-next-line no-unused-vars
import QS from 'qs'
import { Loading } from 'element-ui'
let loading // 定义loading变量
function startLoading () { // 使用Element loading-start 方法
  loading = Loading.service({
    lock: true,
    text: '正在加载中……',
    background: 'rgba(0, 0, 0, 0.6)'
  })
}
function endLoading () { // 使用Element loading-close 方法
  loading.close()
}
let needLoadingRequestCount = 0
export function showFullScreenLoading () {
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  needLoadingRequestCount++
}

export function tryHideFullScreenLoading () {
  if (needLoadingRequestCount <= 0) return
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    endLoading()
  }
}
const isPro = Object.is(process.env.NODE_ENV, 'production')

console.log(isPro)
axios.defaults.baseURL = isPro ? 'https://gjxq.tongxinyizhi.com/gjxq' : 'https://gjxq.tongxinyizhi.com/gjxq'
//axios.defaults.baseURL = isPro ? 'http://localhost/' : 'http://localhost/'
// 环境的切换
// if (process.env.NODE_ENV === 'development') {
//   axios.defaults.baseURL = 'dev/'
// } else if (process.env.NODE_ENV === 'debug') {
//   axios.defaults.baseURL = 'https://app.tongxinyizhi.com/txyz'
// } else if (process.env.NODE_ENV === 'production') {
//   axios.defaults.baseURL = 'https://app.tongxinyizhi.com/txyz'
// }
axios.defaults.timeout = 10000
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
// 请求拦截器
axios.interceptors.request.use(
  config => {
    // 每次发送请求之前判断vuex中是否存在token
    // 如果存在，则统一在http请求的header都加上token，这样后台根据token判断你的登录情况
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
    // const token = store.state.token
    // const token = '2222'
    // token && (config.headers.Authorization = token)
    showFullScreenLoading()
    return config
  },
  error => {
    return Promise.error(error)
  })

// 响应拦截器
axios.interceptors.response.use(
  response => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误
    if (response.status === 200) {
      tryHideFullScreenLoading()
      return Promise.resolve(response)
    } else {
      return Promise.reject(response)
    }
  },
  // 服务器状态码不是2开头的的情况
  // 这里可以跟你们的后台开发人员协商好统一的错误状态码
  // 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
  // 下面列举几个常见的操作，其他需求可自行扩展
  error => {
    return Promise.reject(error.response)
  })
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get (url, params) {
  return new Promise((resolve, reject) => {
    console.log(resolve, reject)
    axios.get(url, {
      params: params
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err.data)
    })
  })
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post (url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, QS.stringify(params))
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}
// // eslint-disable-next-line no-unused-vars
// var axiosBaseUrl = ''
// export default async (url = '', data = {}, type = 'GET', headers = {}) => {
//   type = type.toLowerCase()
//   switch (type) {
//     case 'post':
//       return axios.post(baseUrl + url, data, headers)
//         .then((res) => {
//           return res
//         })
//         .catch((error) => {
//           return error
//         })
//     case 'put':
//       return axios.put(baseUrl + url, data)
//         .then((res) => {
//           return res
//         })
//         .catch((error) => {
//           return error
//         })
//     default:
//       return axios({
//         method: type,
//         baseUrl: baseUrl,
//         url: url,
//         data: data,
//         timeout: 10000,
//         headers: {
//           'X-Requested-With': 'XMLHttpRequest',
//           // 'X-Frame-Options': 'DENY', // 告诉浏览器不要（DENY）把这个网页放在iFrame内，通常的目的就是要帮助用户对抗点击劫持。
//           'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
//         }
//       }).then((res) => {
//         return res
//       }).catch((error) => {
//         return error
//       })
//   }
// }



// WEBPACK FOOTER //
// ./src/api/axios.js